import React, { useState, useEffect, useRef } from "react";
import "./FullWidthCarousel.css";

const FullWidthCarousel = ({
  images,
  interval = 3000,
  paddingLeft = 0,
  paddingRight = 0,
  animation = "crossfade", // Animation type: "slideleft", "slideright", etc.
}) => {
  const [currentIndex, setCurrentIndex] = useState(0); // Active image index
  const [previousIndex, setPreviousIndex] = useState(null); // Previous image index
  const [containerHeight, setContainerHeight] = useState(0); // Dynamic container height
  const carouselRef = useRef(null);

  // Function to update the height dynamically based on the active image
  const updateHeight = () => {
    if (carouselRef.current) {
      const activeImage = carouselRef.current.querySelector(".carousel-image.active");
      if (activeImage) {
        const renderedHeight = activeImage.getBoundingClientRect().height; // Rendered height
        setContainerHeight(renderedHeight || activeImage.clientHeight);
      }
    }
  };

  // Auto-slide logic
  useEffect(() => {
    const intervalId = setInterval(() => {
      setPreviousIndex(currentIndex);
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Loop back to the first image
    }, interval);

    return () => clearInterval(intervalId);
  }, [currentIndex, interval, images.length]);

  // Update height dynamically when the current image or window size changes
  useEffect(() => {
    updateHeight(); // On mount and whenever currentIndex changes
    const handleResize = () => updateHeight(); // Update height on window resize

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [currentIndex]);

  return (
    <div
      ref={carouselRef}
      className={`fullwidth-carousel ${animation}`}
      style={{
        paddingLeft: `${paddingLeft}px`,
        paddingRight: `${paddingRight}px`,
        height: `${containerHeight}px`, // Dynamic height
        width: "100%",
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {images.map((image, index) => (
        <img
          key={index}
          src={image.src}
          alt={image.alt}
          className={`carousel-image ${index === currentIndex ? "active" : ""} ${
            index === previousIndex ? "previous" : ""
          }`}
          onLoad={updateHeight} // Recalculate height when an image loads
        />
      ))}
    </div>
  );
};

export default FullWidthCarousel;
